import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { BaseDateTimePicker } from '../../../../../../shared/components/base-date-time-picker/base-date-time-picker';
import BaseFormInputField from '../../../../../../shared/components/base-input-form-field/base-form-input-field';
import { setDateInputValue } from '../../../../utils/set-date-input-value/set-date-input-value.util';
import { BasicInfoFormikModel } from '../../models/basic-info-formik.model';
import { BasicInfoComponentProps } from '../../types/basic-info-component.props';

export const WifiExpirationDateInput: FunctionComponent<
  BasicInfoComponentProps
> = (props: PropsWithChildren<BasicInfoComponentProps>) => {
  const { values, setFieldValue, errors, touched, setFieldTouched } = props;

  const setWifiExpirationDate = setDateInputValue<BasicInfoFormikModel>(
    setFieldValue,
    'wifiExpirationDate'
  );

  return (
    <FormControl data-testid="wifi-exp-date-input-form-control">
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <BaseDateTimePicker
          value={values.wifiExpirationDate ?? null}
          onChange={setWifiExpirationDate}
          minDate={new Date()}
          onAccept={() => setFieldTouched('wifiExpirationDate', true)}
          renderInput={params => (
            <BaseFormInputField
              {...params}
              className="date-time-picker-input-field"
              label="Wi-fi Expiration Date"
              error={!!errors.wifiExpirationDate && touched.wifiExpirationDate}
              onBlur={() => setFieldTouched('wifiExpirationDate', true)}
              helperText={
                !!errors.wifiExpirationDate &&
                touched.wifiExpirationDate &&
                errors.wifiExpirationDate
              }
              InputLabelProps={{ required: true }}
            />
          )}
        />
      </LocalizationProvider>
    </FormControl>
  );
};
